export default __webpack_public_path__ + "static/media/innovator-hypothesis-template.4dd03be6.pptx";